// Boş dashboard — kayıtlı layout yoksa demo widget gösterilmez

export const defaultDashboard = {
  dashboardId: "main_dashboard",
  name: "Ana Sayfa",
  widgets: [],
};

export const widgetTypes = [
  { type: "statuscard", label: "Status Card", icon: "📊", defaultSize: { w: 2, h: 1 } },
  { type: "gauge", label: "Gauge", icon: "⏱️", defaultSize: { w: 2, h: 1 } },
  { type: "linechart", label: "Line Chart", icon: "📈", defaultSize: { w: 6, h: 3 } },
  { type: "barchart", label: "Bar Chart", icon: "📊", defaultSize: { w: 4, h: 3 } },
  { type: "table", label: "Table", icon: "📋", defaultSize: { w: 6, h: 3 } },
  { type: "edge_logs", label: "Edge Logs", icon: "🖥️", defaultSize: { w: 12, h: 5 } },
];

export const availableMetrics = [
  { key: "temperature", label: "Temperature", unit: "°C" },
  { key: "vibration", label: "Vibration", unit: "mm/s" },
  { key: "pressure", label: "Pressure", unit: "kPa" },
  { key: "voltage", label: "Voltage", unit: "V" },
  { key: "current", label: "Current", unit: "A" },
  { key: "cpu", label: "CPU Usage", unit: "%" },
  { key: "ram", label: "RAM Usage", unit: "%" },
  { key: "disk", label: "Disk Usage", unit: "%" },
];
